import { render, staticRenderFns } from "./DataStudioService.vue?vue&type=template&id=2ec6b6ed&"
import script from "./DataStudioService.vue?vue&type=script&lang=js&"
export * from "./DataStudioService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports